module.exports = __webpack_public_path__ + "static/img/utb-logo.b40a77b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/utb-logo.svg
// module id = yVhq
// module chunks = 1